import {
  OFFER_TYPES_RENT_RESIDENTIAL,
  OFFER_TYPES_RENT_COMMERCIAL,
  OFFER_TYPES_SALE_RESIDENTIAL,
  OFFER_TYPES_SALE_COMMERCIAL,
} from './constants/offerTypes';
import { IOfferType } from './types';
import { FDealType, FOfferType } from '../../../../../JsonQuery';
import { getDailyRentOfferTypes } from '../../../utils/getDailyRentOfferTypes';

export function normalizeOfferType(offerType: FOfferType): FOfferType {
  return (offerType & FOfferType.Residential) !== 0 ? FOfferType.Residential : FOfferType.Commercial;
}

const getOfferTypes = (
  isHotelsEnabled: boolean,
): {
  dealType: FDealType;
  offerType: FOfferType;
  list: IOfferType[][];
}[] => [
  {
    dealType: FDealType.Sale,
    offerType: FOfferType.Residential,
    list: OFFER_TYPES_SALE_RESIDENTIAL,
  },
  {
    dealType: FDealType.Sale,
    offerType: FOfferType.Commercial,
    list: OFFER_TYPES_SALE_COMMERCIAL,
  },
  {
    dealType: FDealType.RentLongterm,
    offerType: FOfferType.Residential,
    list: OFFER_TYPES_RENT_RESIDENTIAL,
  },
  {
    dealType: FDealType.RentLongterm,
    offerType: FOfferType.Commercial,
    list: OFFER_TYPES_RENT_COMMERCIAL,
  },
  {
    dealType: FDealType.RentDaily,
    offerType: FOfferType.Residential,
    list: getDailyRentOfferTypes(isHotelsEnabled),
  },
];

export function getOfferTypeList(dealType: FDealType, offerType: FOfferType, isHotelsEnabled: boolean): IOfferType[][] {
  const type = getOfferTypes(isHotelsEnabled).find(
    t => t.dealType === dealType && t.offerType === normalizeOfferType(offerType),
  );

  return (type && type.list) || [];
}
